import { AdditionalBlockData } from "./additional-block-data";
import { RecordUtils } from "@rsm-hcd/javascript-core";
import { ChecklistItemRecord } from "models/view-models/block-configurations/checklist-item-record";

export interface AdditionalChecklistBlockData extends AdditionalBlockData {
    guardAction?: () => Promise<boolean>;
    isLoadingItems: boolean;
    items: ChecklistItemRecord[];
    onItemsReordered: (
        updatedItems: ChecklistItemRecord[]
    ) => Promise<number[]>;
    updateItems: (newItems: ChecklistItemRecord[]) => void;
}

export const DEFAULT_ADDITIONAL_CHECKLIST_BLOCK_DATA: AdditionalChecklistBlockData =
    {
        guardAction: undefined,
        isLoadingItems: false,
        items: [],
        onItemsReordered: async () => [],
        updateItems: () => {},
    };

export const isChecklistAdditionalData = (
    data: AdditionalBlockData
): data is AdditionalChecklistBlockData => {
    const castedData = data as AdditionalChecklistBlockData;

    return (
        typeof castedData.isLoadingItems === "boolean" &&
        itemsAreValidChecklistItemRecords(castedData.items) &&
        isValidFunction(castedData.onItemsReordered) &&
        isValidFunction(castedData.updateItems)
    );
};

const itemsAreValidChecklistItemRecords = (
    items?: ChecklistItemRecord[]
): boolean => {
    if (items == null) {
        return false;
    }

    return items.every((i) => RecordUtils.isRecord(i, ChecklistItemRecord));
};

const isValidFunction = (maybeFunction?: any): maybeFunction is Function => {
    if (maybeFunction == null) {
        return false;
    }

    return typeof maybeFunction === "function";
};
